import React, { useEffect, useState } from "react";
import { Eye } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { fetchInvestors, onPitchdeck } from "../utils/api";
import { motion, AnimatePresence } from "framer-motion";
import toast from "react-hot-toast";



const InvestorsTactos = () => {

  const startupName = localStorage.getItem("startupName")
  const [data, setData] = useState({ startupName: null, description: null, investorId: null, pitchDeckUrl: null })

  const { data: investors, isLoading } = useQuery({
    queryKey: ["investors"],
    queryFn: fetchInvestors,
    staleTime: 1000 * 60 * 10,
    cacheTime: 1000 * 60 * 30,
    refetchOnWindowFocus: false,
    retry: 1,
  });

  const [selectedInvestor, setSelectedInvestor] = useState(null);
  const [showPitchDeckForm, setShowPitchDeckForm] = useState(false);
  const [loader, setLoader] = useState(false)

  const onSubmitPitchDeck = async (e) => {
    e.preventDefault()
    setLoader(true)
    try {
      if (!data.pitchDeckUrl) {
        setLoader(false)
        setShowPitchDeckForm(false)
        setSelectedInvestor(null)
        toast.error("Please upload pitch deck");
        return;
      }
      const responce = await onPitchdeck(data)
      toast.success(responce.message)
      setData({ ...data, startupName: null, description: null, investorId: null, pitchDeckUrl: null })

    } catch (error) {
      toast.error(error.message)
      console.log(error)
    } finally {
      setLoader(false)
      setShowPitchDeckForm(false)
      setSelectedInvestor(null)
    }
  }

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };



  useEffect(() => {
    console.log(investors)
  }, [investors])

  return (
    <>
      {isLoading ? <InvestorsSkeletonGrid /> : <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold tracking-tight text-gray-900">
            Investors
          </h1>
          <p className="text-gray-500 mt-1">
            Explore investors and their preferred investment ranges.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6">
          {investors?.length === 0 ? (
            <div className="col-span-full flex flex-col items-center justify-center py-16 text-center">
              <div className="text-5xl mb-4"></div>
              <h3 className="text-lg font-semibold text-gray-800">
                No investors found
              </h3>
              <p className="text-sm text-gray-500 mt-1">
                There are no investors available at the moment.
              </p>
            </div>
          ) : (
            investors?.map((investor) => (
              <motion.div
  onClick={() => {
    setSelectedInvestor(investor);
    setShowPitchDeckForm(true);
    setData({
      ...data,
      startupName: startupName,
      investorId: investor._id,
    });
  }}
  key={investor._id}
  initial={{ opacity: 0, y: 20 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.35, ease: "easeOut" }}
  whileHover={{ y: -4 }}
  whileTap={{ scale: 0.98 }}
  className="
    group relative bg-white border border-gray-100 rounded-2xl
    shadow-sm hover:shadow-xl hover:shadow-indigo-500/10
    transition-all duration-300  overflow-hidden
    cursor-pointer
  "
>
              <div
                onClick={() => {
                  setSelectedInvestor(investor);
                  setShowPitchDeckForm(true);
                  setData({ ...data, startupName: startupName, investorId: investor._id })
                }}
                key={investor._id}
                className="
        group relative bg-white border border-gray-100 rounded-2xl
        shadow-sm hover:shadow-xl hover:shadow-indigo-500/10
        transition-all duration-300 p-6 overflow-hidden
      "
              >
                {/* Hover gradient */}
                <div
                  className="
          absolute inset-0 bg-gradient-to-r
          from-indigo-500/5 to-purple-500/5
          opacity-0 group-hover:opacity-100
          transition-opacity rounded-2xl pointer-events-none
        "
                />

                <div className="relative flex items-center gap-5">
                  {/* Image */}
                  <div className="shrink-0">
                    <img
                      src={investor.image}
                      alt={investor.name}
                      className="
              w-16 h-16 rounded-full object-cover
              ring-2 ring-indigo-100
              group-hover:ring-[#fd3e3d]
              transition
            "
                    />
                  </div>

                  {/* Details */}
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2 mb-1">
                      <h3 className="text-lg font-bold text-gray-900 truncate">
                        {investor.name}
                      </h3>

                      {investor.isActive ? (
                        <span className="px-2.5 py-0.5 text-xs font-medium rounded-full
                bg-emerald-50 text-emerald-700 border border-emerald-100">
                          Active
                        </span>
                      ) : (
                        <span className="px-2.5 py-0.5 text-xs font-medium rounded-full
                bg-gray-100 text-gray-600 border border-gray-200">
                          Inactive
                        </span>
                      )}
                    </div>

                    <p className="text-sm text-gray-500 truncate">
                      {investor.email}
                    </p>

                    <div className="flex items-center gap-2 mt-3 text-sm font-semibold text-indigo-600">
                      <span>
                        ₹{investor.investmentRange.minAmount.toLocaleString()}
                      </span>
                      <span className="text-gray-400">–</span>
                      <span>
                        ₹{investor.investmentRange.maxAmount.toLocaleString()}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              </motion.div>
            ))
          )}

        </div>
      </div>}

      {showPitchDeckForm && selectedInvestor && (
        <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center px-4">
          <div className="bg-white rounded-2xl w-full max-w-lg p-6 relative">

            {/* Close Button */}
            <button
              onClick={() => setShowPitchDeckForm(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-black text-lg"
            >
              ✕
            </button>

            {/* Header */}
            <h2 className="text-2xl font-bold text-black mb-1">
              Submit Pitch Deck
            </h2>
            <p className="text-sm text-gray-600 mb-6">
              Investor:{" "}
              <span className="font-semibold text-black">
                {selectedInvestor.name}
              </span>
            </p>

            {/* Form */}
            <form className="space-y-5">

              {/* Startup Name */}
              <div>
                <label className="block text-sm font-semibold text-black">
                  Startup Name
                </label>
                <input
                  type="text"
                  placeholder="Your startup name"
                  value={startupName}
                  readOnly
                  className="
    mt-1 w-full rounded-lg border border-gray-300
    focus:outline-none
    focus:ring-1 focus:ring-[#fd3e3d]
    focus:border-[#fd3e3d]
  "
                  style={{ focusRingColor: "#fd3e3d" }}
                />
              </div>

              {/* Pitch Deck */}
              <div>
                <label className="block text-sm font-semibold text-black">
                  Pitch Deck (PDF)
                </label>
                <input
                  type="file"
                  accept=".pdf"
                  className="
              mt-1 w-full text-sm
              file:mr-4 file:py-2 file:px-4
              file:rounded-md file:border-0
              file:bg-[#fd3e3d] file:text-white
              hover:file:bg-black
            "
                  onChange={async (e) => {
                    const file = e.target.files[0];
                    if (!file) return;

                    // Optional validation
                    if (file.type !== "application/pdf") {
                      alert("Only PDF files are allowed");
                      return;
                    }

                    // Convert to Base64
                    const base64 = await convertToBase64(file);

                    setData((prev) => ({
                      ...prev,
                      pitchDeckUrl: base64,
                    }));
                  }}
                />
              </div>

              {/* Description */}
              <div>
                <label className="block text-sm font-semibold text-black">
                  Short Description
                </label>
                <textarea
                  onChange={(e) => setData({ ...data, description: e.target.value })}
                  rows={3}
                  placeholder="Explain your startup briefly"
                  className="
    mt-1 w-full rounded-lg border border-gray-300
    focus:outline-none
    focus:ring-1 focus:ring-[#fd3e3d]
    focus:border-[#fd3e3d]
  "
                  style={{ focusRingColor: "#fd3e3d" }}
                />
              </div>

              {/* Submit Button */}
              <button
                onClick={onSubmitPitchDeck}
                type="button"
                disabled={loader}
                className={`
    w-full py-2.5 rounded-lg
    text-white font-semibold
    transition flex items-center justify-center gap-2
    ${loader ? "opacity-70 cursor-not-allowed" : ""}
  `}
                style={{ backgroundColor: "#fd3e3d" }}
              >
                {loader ? (
                  <>
                    <span
                      className="
          w-5 h-5 border-2 border-white
          border-t-transparent rounded-full
          animate-spin
        "
                    />
                    Submitting...
                  </>
                ) : (
                  "Submit Pitch Deck"
                )}
              </button>

            </form>
          </div>
        </div>
      )}


    </>

  );
};

export default InvestorsTactos;

const InvestorCardSkeleton = () => {
  return (
    <div
      className="
        relative bg-white border border-gray-100 rounded-2xl
        shadow-sm p-6 overflow-hidden animate-pulse
      "
    >
      <div className="flex items-center gap-5">
        {/* Image Skeleton */}
        <div className="w-16 h-16 rounded-full bg-gray-200" />

        {/* Content Skeleton */}
        <div className="flex-1 space-y-3">
          {/* Name */}
          <div className="h-4 bg-gray-200 rounded w-1/3" />

          {/* Email */}
          <div className="h-3 bg-gray-200 rounded w-2/3" />

          {/* Investment Range */}
          <div className="h-3 bg-gray-200 rounded w-1/2 mt-2" />
        </div>
      </div>
    </div>
  );
};


const InvestorsSkeletonGrid = () => {
  return (
    <>
      <div className="mb-8 animate-pulse">
        {/* Title */}
        <div className="h-8 w-48 bg-gray-200 rounded mb-3" />

        {/* Subtitle */}
        <div className="h-4 w-96 bg-gray-200 rounded" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6">
        {Array.from({ length: 4 }).map((_, index) => (
          <InvestorCardSkeleton key={index} />
        ))}
      </div>
    </>
  );
};
